import { render } from "./World.vue?vue&type=template&id=5f8d0801"
import script from "./World.vue?vue&type=script&lang=js"
export * from "./World.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/World.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f8d0801"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f8d0801', __exports__)) {
    api.reload('5f8d0801', __exports__)
  }
  
  module.hot.accept("./World.vue?vue&type=template&id=5f8d0801", () => {
    api.rerender('5f8d0801', render)
  })

}


export default __exports__